import { render, staticRenderFns } from "./FueTanksDashboard.vue?vue&type=template&id=01841a60"
import script from "./FueTanksDashboard.vue?vue&type=script&lang=js"
export * from "./FueTanksDashboard.vue?vue&type=script&lang=js"
import style0 from "./FueTanksDashboard.vue?vue&type=style&index=0&id=01841a60&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports